import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { addEmployee, AddOrUpdateEmployeeApiModel, EmployeeModel } from "@tCentro/Services/CENAdminEmployeeService";

export interface AddEmployeeParameter extends HasOnSuccess<EmployeeModel>, HasOnError<string> {
    model: AddOrUpdateEmployeeApiModel;
}

type HandlerType = ApiHandler<AddEmployeeParameter, { apiResult: EmployeeModel }>;

export const AddEmployee: HandlerType = async props => {
    try {
        const result = await addEmployee(props.parameter.model);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to add employee");
        }
    }
};

export const chain = [AddEmployee];
const addEmployeeData = createHandlerChainRunner(chain, "addEmployeeData");
export default addEmployeeData;
